/**
 * pap.ts — Categoría "Papelería" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_pap",
  skuPrefix: "PAP",
  categoria: "Papelería",
} as const;

export const cat_pap_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Resma Papel Carta 75gr",
    marca: "Reprograf",
    origen: "Colombia",
    costo: 18500,
    precio: 28900,
    stock: 60,
    stockMinimo: 15,
    stockMaximo: 120,
    unidad: "resma",
    ubicacionFisica: "Estante P1",
    pesoNeto: "2.5kg",
    proveedor: "Propal S.A.",
    descripcionLarga:
      "Resma 500 hojas papel bond blanco tamaño carta, 75gr/m². Ideal impresoras láser e inyección.",
    especificaciones: [
      { clave: "Hojas", valor: "500" },
      { clave: "Gramaje", valor: "75gr/m²" },
    ],
    imageKeywords: ["paper-ream", "office-paper", "bond-paper"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Cuaderno Cuadriculado 100h",
    marca: "Norma",
    modelo: "Escolar Argollado",
    origen: "Colombia",
    costo: 8500,
    precio: 13500,
    stock: 80,
    stockMinimo: 20,
    stockMaximo: 160,
    unidad: "unidad",
    ubicacionFisica: "Estante P2",
    proveedor: "Grupo Carvajal",
    material: "Papel y alambre",
    descripcionLarga:
      "Cuaderno tamaño grande 100 hojas cuadrícula, tapa dura laminada. Argolla reforzada, 5 materias.",
    especificaciones: [
      { clave: "Hojas", valor: "100" },
      { clave: "Formato", valor: "Cuadriculado" },
    ],
    imageKeywords: ["notebook", "school-notebook", "spiral-notebook"],
    color: "bg-blue-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Bolígrafo Bic Cristal x12",
    marca: "Bic",
    modelo: "Cristal Medio",
    origen: "Francia",
    costo: 12500,
    precio: 19900,
    stock: 100,
    stockMinimo: 25,
    stockMaximo: 200,
    unidad: "caja",
    ubicacionFisica: "Góndola P3",
    proveedor: "Bic Colombia",
    colorProducto: "Azul",
    descripcionLarga:
      "Caja 12 bolígrafos Bic Cristal punta mediana, tinta azul. Escritura limpia, rinde 3km línea.",
    especificaciones: [
      { clave: "Unidades", valor: "12" },
      { clave: "Tinta", valor: "Azul" },
    ],
    imageKeywords: ["pens", "bic-pens", "ballpoint"],
    color: "bg-blue-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Set Colores Faber 36",
    marca: "Faber-Castell",
    modelo: "Ecolápices",
    origen: "Alemania",
    costo: 65000,
    precio: 99900,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "estuche",
    ubicacionFisica: "Estante P2",
    proveedor: "Faber-Castell Colombia",
    material: "Madera certificada",
    descripcionLarga:
      "Estuche 36 ecolápices Faber-Castell madera reforestada. Minas suaves de alta pigmentación.",
    especificaciones: [
      { clave: "Colores", valor: "36" },
      { clave: "Material", valor: "Madera FSC" },
    ],
    imageKeywords: ["colored-pencils", "faber-castell", "art-supplies"],
    color: "bg-red-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Marcadores Permanentes x4",
    marca: "Sharpie",
    modelo: "Fine Point",
    origen: "EE.UU.",
    costo: 18500,
    precio: 28900,
    stock: 55,
    stockMinimo: 12,
    stockMaximo: 110,
    unidad: "paquete",
    ubicacionFisica: "Góndola P3",
    proveedor: "Newell Brands",
    descripcionLarga:
      "Pack 4 marcadores Sharpie punta fina (negro, azul, rojo y verde). Tinta permanente, secado rápido.",
    especificaciones: [
      { clave: "Unidades", valor: "4" },
      { clave: "Punta", valor: "1mm" },
    ],
    imageKeywords: ["sharpie-markers", "permanent-markers", "pens"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: 'Carpeta Argollada 2"',
    marca: "Norma",
    modelo: "Classic Oficial",
    origen: "Colombia",
    costo: 22500,
    precio: 34900,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "unidad",
    ubicacionFisica: "Estante P4",
    proveedor: "Grupo Carvajal",
    material: "Cartón y vinilo",
    colorProducto: "Negro",
    descripcionLarga:
      'Carpeta argollada 3 anillos 2" tamaño oficial, capacidad 500 hojas. Bolsillos interiores y exteriores.',
    especificaciones: [
      { clave: "Anillos", valor: "3" },
      { clave: "Capacidad", valor: "500 hojas" },
    ],
    imageKeywords: ["binder", "office-folder", "ring-binder"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Tijeras Escolares",
    marca: "Maped",
    modelo: "Essentials 17cm",
    origen: "Francia",
    costo: 8500,
    precio: 13500,
    stock: 55,
    stockMinimo: 12,
    stockMaximo: 110,
    unidad: "unidad",
    ubicacionFisica: "Estante P5",
    proveedor: "Maped Colombia",
    material: "Acero inoxidable",
    descripcionLarga:
      "Tijeras escolares 17cm punta redondeada, mango ergonómico en ABS. Seguras para niños.",
    especificaciones: [
      { clave: "Longitud", valor: "17cm" },
      { clave: "Punta", valor: "Redondeada" },
    ],
    imageKeywords: ["scissors", "school-scissors", "maped"],
    color: "bg-blue-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Grapadora Oficina",
    marca: "Studmark",
    modelo: "24/6",
    origen: "China",
    costo: 32500,
    precio: 49900,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "unidad",
    ubicacionFisica: "Estante P4",
    proveedor: "Studmark Colombia",
    garantia: "1 año",
    material: "Metal y plástico",
    descripcionLarga:
      "Grapadora estándar metálica oficina grapas 24/6 y 26/6. Capacidad 25 hojas, recarga automática.",
    especificaciones: [
      { clave: "Grapa", valor: "24/6, 26/6" },
      { clave: "Capacidad", valor: "25 hojas" },
    ],
    imageKeywords: ["stapler", "office-stapler", "office-tools"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Cinta Adhesiva Transparente x4",
    marca: "3M",
    modelo: "Scotch Magic",
    origen: "EE.UU.",
    costo: 22500,
    precio: 34900,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "paquete",
    ubicacionFisica: "Góndola P3",
    proveedor: "3M Colombia",
    descripcionLarga:
      "Pack 4 rollos cinta Scotch Magic 19mm x 33m. Invisible en papel, se puede escribir encima.",
    especificaciones: [
      { clave: "Dimensiones", valor: "19mm x 33m" },
      { clave: "Rollos", valor: "4" },
    ],
    imageKeywords: ["scotch-tape", "adhesive-tape", "office-tape"],
    color: "bg-yellow-300",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Calculadora Científica",
    marca: "Casio",
    modelo: "FX-570LA Plus",
    origen: "Tailandia",
    costo: 85000,
    precio: 129000,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Vitrina P6",
    proveedor: "Casio Colombia",
    garantia: "1 año",
    material: "Plástico ABS",
    colorProducto: "Gris",
    descripcionLarga:
      "Calculadora científica 417 funciones, pantalla Natural V.P.A.M. Dos líneas, batería y solar.",
    especificaciones: [
      { clave: "Funciones", valor: "417" },
      { clave: "Pantalla", valor: "Natural V.P.A.M." },
    ],
    imageKeywords: ["scientific-calculator", "casio-calculator", "math-tool"],
    color: "bg-slate-500",
    shape: "square",
  }),
];
